import './placeholderCard.scss';

import { ReactNode } from 'react';

import { PlaceholderCardProps } from './types/PlaceholderCardProps';

export const PlaceholderCard = ({
  testId,
}: PlaceholderCardProps): ReactNode => {
  return (
    <li
      aria-hidden="true"
      className="placeholder-card-item"
      data-testid={testId}
    >
      <div className="placeholder-card" />
    </li>
  );
};
